var uiAssetClassBadge = {
	bond: "Obligatie",
	commodity: "Commodity",
	currency: "Valuta",
	debt: "Schuld",
	etf: "ETF",
	fund: "Fonds",
	generic: "Algemeen",
	index: "Index",
	stock: "Aandeel",
	interestRate: "Rentevoet",
	structuredProduct: "Gestructureerd product",
	investmentProduct: "Investeringsproduct",
	leveragedProduct: "Hefboomproduct",
	future: "Future",
	option: "Optie"
};
var nl = {
	uiAssetClassBadge: uiAssetClassBadge
};

export { nl as default, uiAssetClassBadge };
